import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { withRedux } from "helpers";
import { storeShippoAccessToken, getShippoAccessToken } from "apis";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function Shippo(props) {
  const location = useLocation();
  const search = location.search;
  const classes = useStyles();

  const [error, setError] = useState(null);
  const [code, setCode] = useState(null);
  const [processing, setProcessing] = useState(true);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [appId, setAppId] = useState(null);
  // console.log(new URLSearchParams(search).get("state"));
  // console.log(new URLSearchParams(search).get("code"));
  // console.log(new URLSearchParams(search).get("error"));
  // console.log(new URLSearchParams(search).get("error_description"));

  // const requestAccessToken = async () => {
  //   if (!code) return;
  //   console.log("requesting access token from Shippo...");
  //   try {
  //     const result = await getShippoAccessToken(code);
  //     console.dir(result);
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };

  const postAccessToken = async () => {
    if (!code || !appId) return;
    console.log("setting up access token in m360 db...");
    try {
      const result = await storeShippoAccessToken(appId, code);
      // console.dir(result);
      setProcessing(false);
      setShowSuccessModal(true);
    } catch (e) {
      console.error(e);
      setError(e);
      setShowErrorModal(true);
    }
  };

  useEffect(() => {
    let state = JSON.parse(new URLSearchParams(search).get("state"));
    setError(new URLSearchParams(search).get("error"));
    if (state.validation != "m360Shippo") {
      setError(true);
    }
    setCode(new URLSearchParams(search).get("code"));
    setAppId(state.appId);
    postAccessToken();
  }, [code]);
  // console.log("Processing: " + processing);
  // console.log("Error: " + error);
  // console.log("AppId: " + appId);
  // console.log("Code: " + code);
  if (error)
    return (
      <Modal
        open={showErrorModal}
        disableAutoFocus={true}
        // disableBackdropClick={isNewStoreItem}
        // onClose={() => this.toggleStoreItemOrderingModal()}
        style={{
          margin: "auto",
          width: "35%",
          top: "1%",
          left: "0%",
          overflowY: "auto",
          padding: "1em",
        }}
      >
        <div className={classes.root}>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
              <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                There was an issue connecting to your Shippo account.
                <strong>Please try again,</strong> or contact support if the
                issue persists.
              </Alert>
            </div>
          </Container>
        </div>
      </Modal>
    );
  if (processing) return null;
  return (
    <Modal
      open={showSuccessModal}
      disableAutoFocus={true}
      style={{
        margin: "auto",
        width: "35%",
        top: "1%",
        left: "0%",
        overflowY: "auto",
        padding: "1em",
      }}
    >
      <div className={classes.root}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Alert severity="success">
              <AlertTitle>Success</AlertTitle>
              <strong>Great!</strong> Your discounted shipping via Shippo is
              ready to go. All of your Mobile360 shipping orders will sync
              directly with Shippo.
              {/* <p>{code}</p> */}
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <a href={"/lobby"} style={{ textDecoration: "none" }}>
                  <Button color="primary" variant="contained">
                    Ok
                  </Button>
                </a>
              </div>
            </Alert>
          </div>
        </Container>
      </div>
    </Modal>
  );
}

export default withRedux(Shippo);
